class Addon {
  constructor() {
    this.quantity = 1;
  }

  set(key, value) {
    if(["id", "quantity"].includes(key)) {
      this[key] = value;
    }
  }

  static retrieve(data) {
    var addonParams = this.getAddonParams(data);
    var output = [];
    var tmpMap = {};
    addonParams.forEach(function(key){
      let tmp = key.match(/addons\[(.*)\]\[(.*)\]/) && key.match(/addons\[(.*)\]\[(.*)\]/).slice(1);
      if(tmp.length == 2){
        if(!tmpMap[tmp[1]]) {
          tmpMap[tmp[1]] = new Addon();
          output.push(tmpMap[tmp[1]]);
        }
        tmpMap[tmp[1]].set(tmp[0], data[key]);
      }
    });
    return output;
  }

  static getAddonParams(data) {
    return Object.keys(data).filter(key => key.startsWith("addon"));
  }
}

export default Addon;


// WEBPACK FOOTER //
// ./src/models/addon.js